import { Checkbox } from '@mui/material'
import { memo } from 'react'
import { Field } from 'react-final-form'

import useStyles from '../styles'

function BlocksVisibility() {
  const classes = useStyles({})

  return (
    <>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Promo block</p>
        <Field name="isPromoEnabled">
          {({ input }) => (
            <Checkbox
              className={classes.checkbox}
              checked={input.value}
              onChange={input.onChange}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Payment block</p>
        <Field name="isPaymentEnabled">
          {({ input }) => (
            <Checkbox
              className={classes.checkbox}
              checked={input.value}
              onChange={input.onChange}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Order block</p>
        <Field name="isOrderLookupEnabled">
          {({ input }) => (
            <Checkbox
              className={classes.checkbox}
              checked={input.value}
              onChange={input.onChange}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Upload block</p>
        <Field name="isUploadEnabled">
          {({ input }) => (
            <Checkbox
              className={classes.checkbox}
              checked={input.value}
              onChange={input.onChange}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Time slot</p>
        <Field name="areTimeSlotsEnabled">
          {({ input }) => (
            <Checkbox
              className={classes.checkbox}
              checked={input.value}
              onChange={input.onChange}
            />
          )}
        </Field>
      </div>
    </>
  )
}

export default memo(BlocksVisibility)
